module.exports = __webpack_public_path__ + "static/media/initiative-logo.9f87291c.svg";